/**
 * Constantes relacionadas con UI/UX
 */

// ==========================================
// DURACIONES DE ANIMACIONES
// ==========================================

export const ANIMATION_DURATION = {
  FAST: 150, // ms
  BASE: 200, // ms
  MEDIUM: 300, // ms
  SLOW: 500, // ms
  VERY_SLOW: 1000 // ms
} as const;

// ==========================================
// DURACIONES DE NOTIFICACIONES
// ==========================================

export const NOTIFICATION_DURATION = {
  TOAST: 3000, // 3 segundos
  ALERT: 5000, // 5 segundos
  SUCCESS: 3000, // 3 segundos
  ERROR: 5000, // 5 segundos
  WARNING: 4000, // 4 segundos
  INFO: 3000 // 3 segundos
} as const;

// ==========================================
// BREAKPOINTS RESPONSIVE
// ==========================================

export const BREAKPOINTS = {
  XS: 0,
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1200,
  XXL: 1400
} as const;

// ==========================================
// Z-INDEX SCALE
// ==========================================

export const Z_INDEX = {
  BASE: 0,
  DROPDOWN: 1000,
  STICKY: 1020,
  FIXED: 1030,
  MODAL_BACKDROP: 1040,
  MODAL: 1050,
  POPOVER: 1060,
  TOOLTIP: 1070,
  NOTIFICATION: 1080
} as const;

// ==========================================
// TAMAÑOS DE ICONOS
// ==========================================

export const ICON_SIZE = {
  XS: '12px',
  SM: '16px',
  BASE: '20px',
  MD: '24px',
  LG: '32px',
  XL: '40px',
  XXL: '48px'
} as const;

// ==========================================
// SPACING SCALE (Base 8px)
// ==========================================

export const SPACING = {
  0: '0',
  1: '4px',
  2: '8px',
  3: '12px',
  4: '16px',
  5: '20px',
  6: '24px',
  8: '32px',
  10: '40px',
  12: '48px',
  16: '64px',
  20: '80px',
  24: '96px'
} as const;

// ==========================================
// MENSAJES DE ESTADOS
// ==========================================

export const UI_MESSAGES = {
  LOADING: 'Cargando...',
  PROCESSING: 'Procesando...',
  SAVING: 'Guardando...',
  DELETING: 'Eliminando...',
  UPLOADING: 'Subiendo archivos...',
  DOWNLOADING: 'Descargando...',
  VERIFYING: 'Verificando...',
  SIGNING: 'Firmando documentos...',
  
  // Confirmaciones
  CONFIRM_DELETE: '¿Estás seguro de eliminar este elemento?',
  CONFIRM_CANCEL: '¿Estás seguro de cancelar? Se perderán los cambios.',
  CONFIRM_RESET: '¿Estás seguro de reiniciar? Se perderá toda la información.',
  
  // Vacíos
  NO_DATA: 'No hay datos disponibles',
  NO_RESULTS: 'No se encontraron resultados',
  NO_FILES: 'No hay archivos cargados',
  NO_CERTIFICATES: 'No hay certificados disponibles',
  
  // Genéricos
  SOMETHING_WENT_WRONG: 'Algo salió mal. Intenta nuevamente.',
  TRY_AGAIN: 'Intenta nuevamente',
  CONTACT_SUPPORT: 'Si el problema persiste, contacta a soporte.'
} as const;

// ==========================================
// COLORES DE MARCA (alineados con Flutter app_theme.dart)
// ==========================================

export const BRAND_COLORS = {
  PRIMARY: '#F35B04',       // primaryColor Flutter
  ACCENT: '#F35B04',       // primaryColor
  ORANGE: '#D14A03',       // primaryDark
  ORANGE_LIGHT: '#FF7A33', // primaryLight
  ORANGE_PALE: '#FF7A33'   // primaryLight
} as const;

// ==========================================
// COLORES DE ESTADO
// ==========================================

export const STATE_COLORS = {
  SUCCESS: '#00A86B',
  ERROR: '#E63946',
  WARNING: '#FFB703',
  INFO: '#3b82f6'
} as const;

// ==========================================
// SWEETALERT2 (Swal)
// ==========================================

export const SWAL_DEFAULTS = {
  CONFIRM_BUTTON_TEXT: 'Entendido',
  CUSTOM_CLASS: {
    popup: 'custom-swal-popup',
    title: 'custom-swal-title',
    confirmButton: 'custom-swal-button'
  }
} as const;

// ==========================================
// CONFIGURACIÓN DE MODALES
// ==========================================

export const MODAL_CONFIG = {
  DEFAULT_WIDTH: '600px',
  SMALL_WIDTH: '400px',
  LARGE_WIDTH: '800px',
  FULL_WIDTH: '95vw',
  MAX_HEIGHT: '90vh',
  PANEL_CLASS: 'custom-dialog'
} as const;

// ==========================================
// PATRONES DE VALIDACIÓN
// ==========================================

export const VALIDATION_PATTERNS = {
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  PHONE: /^[0-9]{10}$/,
  NUIP: /^[0-9]{6,10}$/,
  ALPHANUMERIC: /^[a-zA-Z0-9]+$/,
  ONLY_NUMBERS: /^[0-9]+$/,
  ONLY_LETTERS: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/
} as const;

